'use client';

import { LicenseInfo } from '@mui/x-license';

const MUI_PREMIUM_KEY =
    'e8412dbbeffab0b439439712f8bea0fbTz0xMzMyNTYsRT0xODIzODE3NTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9bXVsdGksS1Y9Mg==';

LicenseInfo.setLicenseKey(MUI_PREMIUM_KEY);

export default function MuiXLicense() {
    return null;
}
